import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';
import { JwtService } from '../jwt.service';
import { Contatos } from '../persistences/contatos';

@Injectable({
  providedIn: 'root'
})
export class ContaService {
  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient,
    private jwtService: JwtService,
  ) {}

  getContatos(){
    return this.httpClient.get<Contatos>(
      this.configService.getEndereco() + "/Business/getContatos",{
        headers: this.configService.getHeaders()
      }
    )
  }
}
